import {
  PersonProfileState,
  PersonProfileTypes,
  GET_PERSON_PROFILE_REQ,
  GET_PERSON_PROFILE_RES,
  FAILED_REQUEST,
  UPDATE_PERSON_PROFILE_RES,
  UPDATE_PERSON_PROFILE_REQ,
} from './types';

const initialState: PersonProfileState = { loading: false };

export function personProfileReducer(
  state = initialState,
  action: PersonProfileTypes,
): PersonProfileState {
  switch (action.type) {
    case GET_PERSON_PROFILE_REQ:
      return { ...state, loading: true };
    case GET_PERSON_PROFILE_RES:
      return { ...state, profile: action.payload, loading: false };
    case UPDATE_PERSON_PROFILE_REQ:
      return { ...state, loading: true };
    case UPDATE_PERSON_PROFILE_RES:
      return { ...state, loading: false };
    case FAILED_REQUEST:
      return { ...state, loading: false };
    default:
      return state;
  }
}
